module.exports = __webpack_public_path__ + "safer-behaviours.question.png?27364d8b431940a41322a33babbcc495";